/* unplugin-vue-components disabled */import { render } from "./roles-selector.vue?vue&type=template&id=74735740&scoped=true"
import script from "./roles-selector.vue?vue&type=script&lang=js"
export * from "./roles-selector.vue?vue&type=script&lang=js"

import "./roles-selector.vue?vue&type=style&index=0&id=74735740&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74735740"],['__file',"src/pages/pulse/tracker/roles-selector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74735740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74735740', __exports__)) {
    api.reload('74735740', __exports__)
  }
  
  module.hot.accept("./roles-selector.vue?vue&type=template&id=74735740&scoped=true", () => {
    api.rerender('74735740', render)
  })

}


export default __exports__